//this function is used to retrieve deep properties inside an object
 //while making sure it doesen't brake
 //you have to pass the root object as the first paramete
 //and you pass the path to the desire propertie as a string
 
 //EX: if you have the object 
 //  test = { firstLayer: {
 //      secondLayer: {
 //          thirdLayer: 32
 //      }
 //  }}
 
 //you would call safePropertieRetrieve(test, 'firstLayer.secondLayer.thirdLayer'), returning 32
 
 
 export function safePropertieRetrieve(rootObject: any, stringPath: string) {
    if(stringPath && rootObject){
        if(typeof rootObject === 'object'){
            const layers = stringPath.split('.');
            let lastLayer = rootObject;
            for(let i in layers){
                if(lastLayer[layers[i]]){
                    lastLayer = lastLayer[layers[i]]
                } else {
                    return undefined
                }
            }
            return lastLayer;
        }
    }
